/* src/app/common/mpos-entity/components/di-list-page-header/di-list-page-header.component.scss */
:host di-search-bar {
  max-width: 200px;
}
.disabled:hover {
  cursor: not-allowed;
}
.pointer-events-none {
  pointer-events: none;
}
/*# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsic3JjL2FwcC9jb21tb24vbXBvcy1lbnRpdHkvY29tcG9uZW50cy9kaS1saXN0LXBhZ2UtaGVhZGVyL2RpLWxpc3QtcGFnZS1oZWFkZXIuY29tcG9uZW50LnNjc3MiXSwKICAic291cmNlc0NvbnRlbnQiOiBbIjpob3N0IHtcbiAgICBkaS1zZWFyY2gtYmFyIHtcbiAgICAgICAgbWF4LXdpZHRoOiAyMDBweDtcbiAgICB9XG59XG4uZGlzYWJsZWQ6aG92ZXIge1xuICAgIGN1cnNvcjogbm90LWFsbG93ZWQ7XG59XG4ucG9pbnRlci1ldmVudHMtbm9uZSB7XG4gICAgcG9pbnRlci1ldmVudHM6IG5vbmU7XG59XG4iXSwKICAibWFwcGluZ3MiOiAiO0FBQ0ksTUFBQTtBQUNJLGFBQUE7O0FBR1IsQ0FBQSxRQUFBO0FBQ0ksVUFBQTs7QUFFSixDQUFBO0FBQ0ksa0JBQUE7OyIsCiAgIm5hbWVzIjogW10KfQo= */
